import { serializeToJson } from "@/functional/datetimehelper";
import structuredClone from '@ungap/structured-clone';

export function deepCloneJs(obj: any): any {
  return JSON.parse(serializeToJson(obj));
}

export function deepClone(obj: any): any {
  return structuredClone(obj);
}